import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const AuthSpinner = () => (
  <div className="min-h-screen flex items-center justify-center">
    <div className="animate-spin rounded-full h-32 w-32 border-b-2 border-blue-600"></div>
  </div>
);

const SecureRoute = ({ children, requiredRole, fallbackPath = '/login' }) => {
  const { user, token, isRefreshing, initializing } = useAuth();

  // Wait for the stored session to be restored / refreshed before deciding.
  // Redirecting here is what used to force a re-login in every new tab.
  if (initializing || isRefreshing) {
    return <AuthSpinner />;
  }

  // Check if user is authenticated
  if (!user || !token) {
    return <Navigate to={fallbackPath} replace />;
  }

  // Check if user has required role
  if (requiredRole && user.role !== requiredRole) {
    return <Navigate to="/unauthorized" replace />;
  }

  // Check token expiration
  try {
    const tokenPayload = JSON.parse(atob(token.split('.')[1]));
    const currentTime = Date.now() / 1000;

    if (tokenPayload.exp < currentTime) {
      // Token is expired, redirect to login
      return <Navigate to={fallbackPath} replace />;
    }
  } catch (error) {
    // Invalid token format, redirect to login
    return <Navigate to={fallbackPath} replace />;
  }

  return children;
};

export default SecureRoute;
